/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-03 15:58:53
 *
 *******************************************************/
// @flow

import React, { useState, useCallback, useEffect } from 'react';
import {
  Icon,
  Button,
  ActionList,
  Popover,
  TextField
} from '@shopify/polaris';
import { TickSmallMinor, SearchMinor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

const CollectionAnalyticActionList = (props: WithI18nProps) => {

  const { i18n, collections, handleSelectCollection, currenCollectionId = 'all' } = props;
  const [collectionsCurrentSession, updateCollectionsCurrentSession] = useState(collections);
  const [currentKeySearch, updateCurrentKeySearch] = useState("");
  const [active, setActive] = useState(false);

  useEffect(() => {
    const tmpCollections = collections.filter(collection => {
      if (collection.title.toLowerCase().includes(currentKeySearch.toLowerCase())) return true;
      return false;
    })
    updateCollectionsCurrentSession(tmpCollections)
  }, [currentKeySearch, collections])

  const toggleActive = useCallback(() => setActive(active => !active), []);

  const activator = (
    <Button onClick={toggleActive} disclosure>
      {
        currenCollectionId === 'all' ? 
        i18n.translate('AdminHTML.Analytics.CollectionAnalytics.allCollections') : 
        collections.find(collection => collection.id === currenCollectionId)?.title
      }
    </Button>
  );

  return (
    <div className="CollectionAnalyticActionList">
      <Popover 
        active={active}
        activator={activator}
        onClose={toggleActive}
        autofocusTarget="first-node"
        preferredPosition="mostSpace"
        preferredAlignment="right"
      >
        <div className="CollectionAnalyticActionList__Popup">
          <div className='CollectionAnalyticActionList__Search'>
            <TextField
              onChange={value => updateCurrentKeySearch(value)}
              value={currentKeySearch}
              prefix={<Icon source={SearchMinor} color="base" />}
              placeholder={i18n.translate(
                'AdminHTML.Analytics.CollectionAnalytics.searchCollection'
              )}
            />
          </div>
          <ActionList
            sections={[
              {
                items: [
                  {
                    content: i18n.translate(
                      'AdminHTML.Analytics.CollectionAnalytics.allCollections'
                    ),
                    suffix: currenCollectionId === "all" && <Icon source={TickSmallMinor} />,
                    active: currenCollectionId === "all",
                    onAction: () => handleSelectCollection('all')
                  },
                  ...collectionsCurrentSession.map(collection => {
                  return {
                    content: collection.title,
                    suffix: currenCollectionId === collection.id && <Icon source={TickSmallMinor} />,
                    active: currenCollectionId === collection.id,
                    onAction: () => {
                      toggleActive();
                      handleSelectCollection(collection.id);
                    }
                  }
                })
                ]
              }
            ]}
          />
        </div>
      </Popover>
    </div>
  );
};

export default withI18n()(CollectionAnalyticActionList);
